import { render, staticRenderFns } from "./AssignStatusOnContactSDData.vue?vue&type=template&id=c6edf1d2&scoped=true"
import script from "./AssignStatusOnContactSDData.vue?vue&type=script&lang=js"
export * from "./AssignStatusOnContactSDData.vue?vue&type=script&lang=js"
import style0 from "./AssignStatusOnContactSDData.vue?vue&type=style&index=0&id=c6edf1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6edf1d2",
  null
  
)

export default component.exports